var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLmLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "40px",
    viewBox: "0 0 38 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logos /  Locate + Mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter-Bar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map-View-Filter-Bar-Idea-Filtering",
    transform: "translate(-25.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logos-/--Locate-+-Mark",
    transform: "translate(24.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1.111111, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2073766,14.3969367 C37.5799118,15.8908429 37.7777778,17.4548087 37.7777778,19.0654206 C37.7777778,29.0916433 30.1100953,37.3102457 20.3706152,38.0730449 L20.3706934,35.8222708 C28.8813095,35.0654697 35.5555556,27.8521563 35.5555556,19.0654206 C35.5555556,17.8333557 35.4243313,16.6322263 35.1752201,15.4754945 C35.9165996,15.350422 36.5836155,15.0009929 37.1057285,14.499324 Z M18.8888889,0 C25.2600267,0 30.8944376,3.1837822 34.3156414,8.06106744 C33.5065389,8.11203753 32.7680504,8.42573881 32.1825121,8.9183779 C29.1407405,4.86309219 24.3179603,2.24299065 18.8888889,2.24299065 C9.68414306,2.24299065 2.22222222,9.77464907 2.22222222,19.0654206 C2.22222222,25.696048 6.02285866,31.430693 11.5452205,34.1710156 L10.7442032,36.2723193 C4.38926708,33.202268 0,26.6512189 0,19.0654206 C0,8.53587954 8.45684361,0 18.8888889,0 Z",
    id: "Combined-Shape",
    fill: "#0089C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5524691,10.2959502 C35.3706688,10.2959502 36.0339506,10.9654309 36.0339506,11.7912773 C36.0339506,12.6171236 35.3706688,13.2866044 34.5524691,13.2866044 C33.7342695,13.2866044 33.0709877,12.6171236 33.0709877,11.7912773 C33.0709877,10.9654309 33.7342695,10.2959502 34.5524691,10.2959502 Z",
    id: "Path",
    fill: "#0089C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8888889,5.98130841 C26.0481356,5.98130841 31.8518519,11.839265 31.8518519,19.0654206 C31.8518519,25.7858146 26.8321142,31.3228288 20.3706788,32.0649837 L20.3703991,29.8042535 C25.6012627,29.0758314 29.6296296,24.5454603 29.6296296,19.0654206 C29.6296296,13.0780345 24.8208362,8.22429907 18.8888889,8.22429907 C18.0484289,8.22429907 17.2305154,8.3217342 16.4456311,8.50602383 C16.2481986,7.7137594 15.7993739,7.02192448 15.1899558,6.52174203 C16.3618303,6.17013908 17.6035119,5.98130841 18.8888889,5.98130841 Z M9.25574919,10.3091519 C9.44694106,11.1036599 9.88963598,11.798884 10.4939315,12.3040817 C9.02602232,14.1559654 8.14814815,16.5072156 8.14814815,19.0654206 C8.14814815,23.1476919 10.3836,26.7029658 13.6863322,28.5521533 L12.8823722,30.6631844 C8.7473105,28.4769235 5.92592593,24.1037362 5.92592593,19.0654206 C5.92592593,15.7620351 7.13878417,12.7445754 9.13954979,10.4419637 Z",
    id: "Combined-Shape",
    fill: "#0089C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8549383,7.92834891 C13.6731379,7.92834891 14.3364198,8.59782966 14.3364198,9.42367601 C14.3364198,10.2495224 13.6731379,10.9190031 12.8549383,10.9190031 C12.0367386,10.9190031 11.3734568,10.2495224 11.3734568,9.42367601 C11.3734568,8.59782966 12.0367386,7.92834891 12.8549383,7.92834891 Z",
    id: "Path",
    fill: "#0089C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8888889,12.3364486 C22.5707872,12.3364486 25.5555556,15.349112 25.5555556,19.0654206 C25.5555556,22.2670528 23.3402687,24.9464414 20.3724325,25.6271786 L20.3722771,23.2954603 C22.0974919,22.6790871 23.3333333,21.0179258 23.3333333,19.0654206 C23.3333333,16.5878815 21.3434878,14.5794393 18.8888889,14.5794393 C16.43429,14.5794393 14.4444444,16.5878815 14.4444444,19.0654206 C14.4444444,20.4303237 15.048368,21.6528546 16.0012153,22.4756303 L15.1721968,24.6524741 C13.3928408,23.4441792 12.2222222,21.3927838 12.2222222,19.0654206 C12.2222222,15.349112 15.2069906,12.3364486 18.8888889,12.3364486 Z",
    id: "Combined-Shape",
    fill: "#0089C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8888889,17.5700935 C19.7070885,17.5700935 20.3703704,18.2395742 20.3703704,19.0654206 C20.3703704,19.8912669 19.7070885,20.5607477 18.8888889,20.5607477 C18.0706893,20.5607477 17.4074074,19.8912669 17.4074074,19.0654206 C17.4074074,18.2395742 18.0706893,17.5700935 18.8888889,17.5700935 Z",
    id: "Path",
    fill: "#0089C4",
    fillRule: "nonzero",
    transform: "translate(18.888889, 19.065421) scale(1, -1) translate(-18.888889, -19.065421) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8250833,21.8575344 C18.1552653,21.9857798 18.513944,22.0560748 18.8888889,22.0560748 L18.8888889,22.0560748 L18.8888889,40 L11.4814815,38.5046729 Z",
    id: "Combined-Shape",
    fill: "#FFA100"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLmLogoBlue);
export default __webpack_public_path__ + "static/media/lm-logo-blue.9a5ebf58ab28de8d4a49218955030ed7.svg";
export { ForwardRef as ReactComponent };